import React, { useState, useEffect,useRef} from "react";
import { Input, Select, Button,message,Modal } from "antd";
import { PlusCircleOutlined, DeleteOutlined,EllipsisOutlined,CopyOutlined,WarningOutlined } from "@ant-design/icons";
import { rebuildFormula } from "@/config/func";
// import test_Rectisol from "@/constants/test_Rectisol.json";
import test_Rectisol from "@/constants/defaultValue.json";
import { unitMap } from "@/constants/dataMap";

interface ParameterEditorProps {
  // 基础信息数据
  localFormData: Record<string, any>;
  setLocalFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  // 参数配置数据
  modalParams: any[] | null;
  localParamValues: Record<string, any>;
  setLocalParamValues: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  // 流股组分数据
  materialsData: any;
  localMaterialsData: Record<string, any>;
  setLocalMaterialsData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  // 辅助信息
  globalData?: any;
  selectElement: string;
  maxHeight:number | string;
  designVisible:boolean;
  fastModalVariable:boolean;
  closeFastModal:() => void;
  saveAbled:(saveAbled:boolean) => void;
  readonly?:any;
  isShowDescription?:boolean;
  elementPage?:string|null;
}

const ParameterEditor: React.FC<ParameterEditorProps> = ({
  localFormData,
  setLocalFormData,
  modalParams,
  localParamValues,
  setLocalParamValues,
  materialsData,
  localMaterialsData,
  setLocalMaterialsData,
  globalData,
  selectElement,
  maxHeight,
  designVisible,
  fastModalVariable,
  closeFastModal,
  saveAbled,
  readonly,
  isShowDescription,
  elementPage,
}) => {

  const [messageApi, contextHolder] = message.useMessage();
  const [modalVariable, setModalVariable] = useState(false);
  const [copyMaterialsDataTxt, setCopyMaterialsDataTxt] = useState("");
  const [fastJsonStr, setFastJsonStr] = useState("");
  const [errorInputs,setErrorInputs] = useState([]);

  useEffect(() => 
  {
    let newfastJson = JSON.stringify(buildFastJson(localParamValues),null,4);
    setFastJsonStr(newfastJson);
  }, [fastModalVariable]);

  useEffect(() => 
  {
    if(localFormData && modalParams)
    {
      //切换元件
      let newErrorInputs = [];

      // //特殊处理
      // if(localParamValues["塔板数"])
      // {
      //   let N = Number(localParamValues["塔板数"].value);
      //   if (Number.isNaN(N))
      //   {
      //     N = null;
      //   }
      //   let Nos = localParamValues["出料流股位置"].p_children;
      //   let Nss = localParamValues["进料流股位置"].p_children;
      //   let NoValues = Nos.map(obj => obj["出料位置"].value);
      //   let NsValues = Nss.map(obj => obj["进料位置"].value);
        
      //   if(N && N>=1 && Number.isInteger(N))
      //   {
      //     //恢复状态
      //     newErrorInputs = newErrorInputs.filter(i => i !== "N");

      //     //判断No与Ns的值
      //     for(let i=0;i<NoValues.length;i++)
      //     {
      //       let value = Number(NoValues[i]);
      //       if (Number.isNaN(value))
      //       {
      //         value = null;
      //       }
      //       if(value && value<=N && value>=1 && Number.isInteger(value))
      //       {
      //         newErrorInputs = newErrorInputs.filter(j => j !== `No_${i}`);
      //       }
      //       else
      //       {
      //         newErrorInputs.push(`No_${i}`);
      //       }
      //     }
      //     for(let i=0;i<NsValues.length;i++)
      //     {
      //       let value = Number(NsValues[i]);
      //       if (Number.isNaN(value))
      //       {
      //         value = null;
      //       }
      //       if(value && value<=N && value>=1 && Number.isInteger(value))
      //       {
      //         newErrorInputs = newErrorInputs.filter(j => j !== `Ns_${i}`);
      //       }
      //       else
      //       {
      //         newErrorInputs.push(`Ns_${i}`);
      //       }
      //     }
      //   }
      //   else
      //   {
      //     //error状态
      //     let newErrorInputs = [...errorInputs];
      //     newErrorInputs.push("N");

      //     //如果N有误，则No与Ns都有误
      //     for(let i=0;i<NoValues.length;i++)
      //     {
      //       newErrorInputs.push(`No_${i}`);
      //     }
      //     for(let i=0;i<NsValues.length;i++)
      //     {
      //       newErrorInputs.push(`Ns_${i}`);
      //     }
      //   }
      // }

      setErrorInputs(newErrorInputs);
    }
  }, [localFormData,modalParams]);

  useEffect(() => 
  {
    if(errorInputs.length>0)
    {
      saveAbled(false);
    }
    else
    {
      saveAbled(true);
    }
  }, [errorInputs]);

  const copyMaterialsData = () => 
  {
    let copyMaterialsDataArr = copyMaterialsDataTxt.split('\n');

    if(globalData.materials)
    {
      let newLocalMaterialsData = {...localMaterialsData};

      for(let i=0;i<globalData.materials.length;i++)
      {
        let formula = globalData.materials[i].formula;
        if(copyMaterialsDataArr[i])
        {
          newLocalMaterialsData[formula].molar_frac = copyMaterialsDataArr[i];
          newLocalMaterialsData[formula].desValue = copyMaterialsDataArr[i];
        }
        else
        {
          break;
        }
      }

      setLocalMaterialsData(newLocalMaterialsData);
    }

    setCopyMaterialsDataTxt("");
    setModalVariable(false);
  }

  const buildFastJson = (data) =>
  {
    if(data && Object.keys(data).length>0)
    {
      let newfastJson = {};
      for(let key in data) 
      {
        if(data[key].show && !data[key].p_children)
        {
          newfastJson[key] = data[key].value;
        }
      }

      return newfastJson;
    }
    else 
    {
      return {};
    }
  }

  const confirmFastJson = () =>
  {
    try 
    {
      // console.log("localParamValues",localParamValues);
      let newLocalParamValues = {...localParamValues};
      let fastJson = JSON.parse(fastJsonStr);
      for(let key in fastJson)
      {
        if(newLocalParamValues[key])
        {
          newLocalParamValues[key].value = fastJson[key];
        }
        else
        {
          throw new Error(`字段 ${key} 不存在`);
        }
      }

      setLocalParamValues(newLocalParamValues);
      closeFastModal();
    } 
    catch(e)
    {
      let messageTxt = e.message;

      messageApi.open
      ({
        type:"error",
        content:messageTxt,
      });
    }
  }
  
  return (
    <>
      {contextHolder}
      <div style={{display:"flex",flexDirection: "row"}}>
        {isShowDescription?(
          <div style={{width:280,marginRight:20}}>
            <div style={{display:elementPage?"flex":"none",alignItems: "center",justifyContent: "center",height:elementPage?"50%":"0%",marginTop:"5%",border:"1px solid #BBB",padding:5}}>
              {elementPage?(
                <img
                  src={elementPage} 
                  style={{maxHeight:"100%", }} 
                />
              ):null}
            </div>
            <div style={{height:elementPage?"40%":"100%",marginTop:"5%"}}>
              <div
                key={"描述"}
                style={{ display: "flex", marginBottom: "10px",height:"100%"}}
              >
                <div style={{ width: "40px", fontSize: 14,marginTop:5 }}>描述</div>

                {readonly?(
                  <div style={{ flex: 1,minHeight:"100%",maxHeight:"100%",fontSize:14,color:"#000",marginTop:5}}>
                    {localFormData?.["描述"]?.value ?? ""}
                  </div>
                ):(
                  <Input.TextArea
                    autoSize={{maxRows:undefined}}
                    value={localFormData?.["描述"]?.value ?? ""}
                    onChange={(e) => {
                      setLocalFormData((prev) => ({
                        ...prev,
                        ["描述"]: {
                          value: e.target.value,
                          show: false,
                          engName: "description",
                        },
                      }));
                    }}
                    style={{ flex: 1,minHeight:"100%",maxHeight:"100%"}}
                  />
                )}
              </div>
            </div>
          </div>
        ):null}

        <div style={{ maxHeight: maxHeight, overflowY: "auto", padding: 10,width:"100%" }}>
          {/* 基础信息区域 */}
          {localFormData &&
            typeof localFormData === "object" &&
            !Array.isArray(localFormData) &&
            Object.entries(localFormData).map(([key]) => (
              <div
                key={key}
                style={{
                  display:localFormData[key]?.show===undefined ? "flex" : (localFormData[key].show===false?"none":"flex"),
                  // display: "flex",
                   alignItems: "center", marginBottom: "10px" }}
              >
                <div style={{ width: "120px", fontSize: 14 }}>{key==="分组名称"?"工艺段名称":key}</div>
                {localFormData[key]?.enum ? (
                  <Select
                    value={localFormData[key]?.value ?? ""}
                    onChange={(selectedValue) => 
                    {
                      if(key==="计算模式" && localParamValues["温度"] && localParamValues["汽相分率"])
                      {
                        if(selectedValue==="TP")
                        {
                          setLocalFormData((prev) => ({
                            ...prev,
                            [key]: {
                              value: selectedValue,
                              show: localFormData[key].show ?? false,
                              engName: localFormData[key].engName ?? "",
                              enum: localFormData[key].enum ?? null,
                            },
                          }));
                          setLocalParamValues((prev) => ({
                            ...prev,
                            ["温度"]:{
                              ...prev["温度"],
                              show:true,
                            },
                            ["汽相分率"]:{
                              ...prev["汽相分率"],
                              show:false,
                            }
                          }));
                        }
                        else if(selectedValue==="VP"||selectedValue==="HP")
                        {
                          setLocalFormData((prev) => ({
                            ...prev,
                            [key]: {
                              value: selectedValue,
                              show: localFormData[key].show ?? false,
                              engName: localFormData[key].engName ?? "",
                              enum: localFormData[key].enum ?? null,
                            },
                          }));
                          setLocalParamValues((prev) => ({
                            ...prev,
                            ["温度"]:{
                              ...prev["温度"],
                              show:false,
                            },
                            ["汽相分率"]:{
                              ...prev["汽相分率"],
                              show:true,
                            }
                          }));
                        }
                      }
                      else
                      {
                        setLocalFormData((prev) => ({
                          ...prev,
                          [key]: {
                            value: selectedValue,
                            show: localFormData[key].show ?? false,
                            engName: localFormData[key].engName ?? "",
                            enum: localFormData[key].enum ?? null,
                          },
                        }));
                      }
                    }}
                    style={{ flex: 1 }}
                    options={localFormData[key].enum.map((opt: any) => ({
                      label: opt.label,
                      value: opt.value,
                    }))}
                  />
                ) : (
                  <div style={{ flex: 1 }}>
                    {(readonly && (key==="元件名称"||key==="流股名称"||key==="分组名称"))?
                      (
                        <div style={{ flex:1, fontSize: 14,marginBottom:10 }}>
                          {localFormData[key]?.value ?? ""}
                        </div>
                      ):
                      (
                        <Input
                          value={localFormData[key]?.value ?? ""}
                          onChange={(e) => {
                            setLocalFormData((prev) => ({
                              ...prev,
                              [key]: {
                                value: e.target.value,
                                show: localFormData[key].show ?? false,
                                engName: localFormData[key].engName ?? "",
                              },
                            }));
                          }}
                          style={{ flex: 1 }}
                        />
                      )
                    }
                  </div>
                )}
              </div>
            ))}

          {/* 参数区域 */}
          {modalParams &&
            Array.isArray(modalParams) &&
            modalParams.filter(item=>!item.p_class).map((item) => (
              <div
                key={item?.p_name}
                style={{
                  // display: item.p_show||localParamValues[item.p_name]?.show ? "flex" : "none",
                  display: ((localParamValues["冷流股出口温度"] && localParamValues["热流股出口温度"] && localParamValues["冷流股出口压力"] && localParamValues["热流股出口压力"])&&(item.p_engName==="cold_out_T"||item.p_engName==="cold_out_P"||item.p_engName==="hot_out_T"||item.p_engName==="hot_out_P"))?"flex":
                  ((localParamValues["冷流股出口温度"] && localParamValues["热流股出口温度"] && localParamValues["冷流股出口压力"] && localParamValues["热流股出口压力"])&&(item.p_engName==="streamAttribute")?"none":
                  (item.p_show||localParamValues[item.p_name]?.show ? "flex" : "none")),
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: item.p_show||localParamValues[item.p_name]?.show ? "10px" : "0px",
                }}
              >
                {/* 有 p_children 的情况 */}
                {item.p_children && Array.isArray(item.p_children) && item.p_children.length > 0 ? (
                  <div style={{ width: "100%", marginBottom: "10px" }}>
                    {!(item.p_engName === "No" || item.p_engName === "Ns" || item.p_engName === "output_f" || item.p_engName === "cold_out_T" || item.p_engName === "hot_out_T" || item.p_engName === "cold_out_P" || item.p_engName === "hot_out_P" || item.p_engName === "stream_type" || item.p_engName === "streamRelationship" ) ? (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                          }}
                        >
                          <div
                            style={{
                              width: "120px",
                              fontSize: 14,
                              fontWeight: "bold",
                              color: "#1b6ae7",
                            }}
                          >
                            {item.p_name}
                          </div>
                          <Button
                            type="text"
                            style={{
                              height: 30,
                              width: 30,
                              borderRadius: 50,
                              backgroundColor: "#FFF",
                            }}
                            onClick={() => 
                            {
                              setLocalParamValues((prev) => {
                                const current = prev[item.p_name] || {
                                  p_children: [],
                                  show: item.p_show,
                                  engName: item.p_engName,
                                };
                                const newChild: any = {};
                                item.p_children.forEach((sub: any) => {
                                  newChild[sub.p_name] = {
                                    // value: (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                    //   ?.find((c: any) => c.p_name === sub.p_name)?.p_value,
                                    value: (
                                      (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[0]?.[sub.p_engName] )
                                      ??(modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                      ?.find((c: any) => c.p_name === sub.p_name)?.p_value),
                                    desValue: (
                                      (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[0]?.[sub.p_engName] )
                                      ??(modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                      ?.find((c: any) => c.p_name === sub.p_name)?.p_value),
                                    show: sub.p_show ?? true,
                                    engName: sub.p_engName ?? "",

                                  };
                                  if(item.p_children.find(field=>field.p_engName===sub.p_engName).p_children)
                                  {
                                    let children = [];
                                    if(sub.p_engName==="spec")
                                    {
                                      for(let i=0;i<globalData.materials.length;i++)
                                      {
                                        let child = 
                                        {
                                          "组分": 
                                          {
                                            value: globalData.materials[i].name,
                                            show:true,
                                            engName: "组分",
                                            readonly:true,
                                          },
                                          "效率值": 
                                          {
                                            value:(item.p_children.find(field=>field.p_engName===sub.p_engName).p_children).find(field=>field?.p_name==="效率值")?.p_value??"",
                                            desValue:(item.p_children.find(field=>field.p_engName===sub.p_engName).p_children).find(field=>field?.p_name==="效率值")?.p_value??"",
                                            show:true,
                                            engName:"效率值",
                                          },
                                        };
                                        children.push(child);
                                      }
                                    }
                                    newChild[sub.p_name].children = children;
                                  }
                                });
                                const newChildren = [...(current.p_children || []), newChild];
                                return {
                                  ...prev,
                                  [item.p_name]: {
                                    ...current,
                                    p_children: newChildren,
                                  },
                                };
                              });
                            }}
                          >
                            <PlusCircleOutlined style={{ fontSize: 20, color: "#1b6ae7" }} />
                          </Button>
                        </div>
                        {(localParamValues[item.p_name]?.p_children || []).map((child: any, idx: number) => (
                          <div
                            key={idx}
                            style={{
                              border: "1px solid #BBB",
                              padding: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                marginBottom: "10px",
                                paddingRight: "10px",
                              }}
                            >
                              <Button type="text" style={{height: 30,width: 30,borderRadius: 50,backgroundColor: "#FFF",}}
                                onClick={() =>
                                {
                                  let children = []
                                  if(item.p_engName==="eff")
                                  {
                                    for(let i=0;i<globalData.materials.length;i++)
                                    {
                                      let child = 
                                      {
                                        "组分": 
                                        {
                                          value: globalData.materials[i].name,
                                          show:true,
                                          engName: "组分",
                                          readonly:true,
                                        },
                                        "效率值": 
                                        {
                                          value:(item.p_children.find(field=>field.p_engName==="spec")?.p_children).find(field=>field?.p_name==="效率值")?.p_value??"",
                                          desValue:(item.p_children.find(field=>field.p_engName==="spec")?.p_children).find(field=>field?.p_name==="效率值")?.p_value??"",
                                          show:true,
                                          engName:"效率值",
                                        },
                                      };
                                      children.push(child);
                                    }
                                    setLocalParamValues(prev => ({
                                      ...prev,
                                      [item.p_name]: {
                                        ...prev[item.p_name],
                                        p_children: prev[item.p_name].p_children.map((child, i) =>
                                          i === idx ? { ...child, "特殊效率": { ...child["特殊效率"], show:!child["特殊效率"]?.show,children:children} } : child
                                        )
                                      }
                                    }));
                                  }
                                  else
                                  {
                                    messageApi.open({
                                      type: "error",
                                      content: "暂无额外数据",
                                    });
                                  }
                                }}
                              >
                                <EllipsisOutlined style={{ fontSize: 20, color: "#1b6ae7" }} />
                              </Button>

                              <Button
                                type="text"
                                style={{
                                  height: 30,
                                  width: 30,
                                  borderRadius: 50,
                                  backgroundColor: "#FFF",
                                }}
                                onClick={() => {
                                  setLocalParamValues((prev) => {
                                    const current = prev[item.p_name];
                                    const newChildren = current.p_children.filter(
                                      (_: any, i: number) => i !== idx
                                    );
                                    return {
                                      ...prev,
                                      [item.p_name]: {
                                        ...current,
                                        p_children: newChildren,
                                      },
                                    };
                                  });
                                }}
                              >
                                <DeleteOutlined style={{ fontSize: 20, color: "#FF4D4F" }} />
                              </Button>
                            </div>
                            {item.p_children.map((sub: any) => (
                              <div
                                key={sub.p_name}
                                style={{display:sub.p_show||child[sub.p_name]?.show?"flex":"none",alignItems:child[sub.p_name]?.children?"stretch":"center",marginTop:child[sub.p_name]?.children?15:0,marginBottom: "10px"}}
                              >
                                <div style={{ width: "100px", fontSize: 14 }}>{sub.p_name}</div>
                                {sub.p_children ? (
                                  <div style={{ flex: 1 }}>
                                    {(child[sub.p_name].children || []).map((child2,idx2) => (
                                      <div key={idx2} style={{border: '1px solid #BBB',marginBottom:10,padding:10}}>
                                        {sub.p_children.map((field) => (
                                          <div
                                            key={field.p_name}
                                            style={{ display:'flex',alignItems:'center',marginBottom:10}}
                                          >
                                            <div style={{ width:80,fontSize:14}}>{field.p_name}</div>
                                            {child2[field.p_name].readonly ? (
                                              <div style={{ flex: 1,fontSize:14 }}>{child2[field.p_name].value??''}</div>
                                            ) : (
                                              <div style={{ flex: 1,display:"flex",flexDirection:"row"}}>
                                                <Input
                                                  value={child2[field.p_name].value ?? ''}
                                                  onChange={(e) => 
                                                  {
                                                    const newVal = e.target.value;
                                                    // 更新 specChild 中对应字段的值
                                                    const newSpecChildren = [...(child[sub.p_name]?.children || [])];
                                                    newSpecChildren[idx2] = {
                                                      ...newSpecChildren[idx2],
                                                      [field.p_name]: {
                                                        ...newSpecChildren[idx2][field.p_name],
                                                        value: newVal,
                                                      },
                                                    };
                                                    const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                    newChildren[idx] = {
                                                      ...child,
                                                      [sub.p_name]: {
                                                        ...child[sub.p_name],
                                                        children: newSpecChildren,
                                                      },
                                                    };
                                                    setLocalParamValues((prev: any) => ({
                                                      ...prev,
                                                      [item.p_name]: {
                                                        ...prev[item.p_name],
                                                        p_children: newChildren,
                                                      },
                                                    }));
                                                  }}
                                                  style={{ flex: 1 }}
                                                />
                                                {(designVisible?(
                                                  <Input
                                                    value={child2[field.p_name].desValue ?? ''}
                                                    onChange={(e) => 
                                                    {
                                                      const newVal = e.target.value;
                                                      // 更新 specChild 中对应字段的值
                                                      const newSpecChildren = [...(child[sub.p_name]?.children || [])];
                                                      newSpecChildren[idx2] = {
                                                        ...newSpecChildren[idx2],
                                                        [field.p_name]: {
                                                          ...newSpecChildren[idx2][field.p_name],
                                                          desValue: newVal,
                                                        },
                                                      };
                                                      const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                      newChildren[idx] = {
                                                        ...child,
                                                        [sub.p_name]: {
                                                          ...child[sub.p_name],
                                                          children: newSpecChildren,
                                                        },
                                                      };
                                                      setLocalParamValues((prev: any) => ({
                                                        ...prev,
                                                        [item.p_name]: {
                                                          ...prev[item.p_name],
                                                          p_children: newChildren,
                                                        },
                                                      }));
                                                    }}
                                                    style={{ flex: 1,marginLeft:10 }}
                                                  />
                                                ):null)}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <div style={{flex:1,display:"flex",flexDirection:"row"}}>
                                    <Input
                                      value={child[sub.p_name]?.value ?? ''}
                                      onChange={(e) => {
                                        const newVal = e.target.value;
                                        const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                        newChildren[idx] = {
                                          ...newChildren[idx],
                                          [sub.p_name]: {
                                            ...newChildren[idx]?.[sub.p_name],
                                            value: newVal,
                                          },
                                        };
                                        setLocalParamValues((prev: any) => ({
                                          ...prev,
                                          [item.p_name]: {
                                            ...prev[item.p_name],
                                            p_children: newChildren,
                                          },
                                        }));
                                      }}
                                      style={{ flex: 1 }}
                                    />
                                    {(designVisible?(
                                      <Input
                                        value={child[sub.p_name]?.desValue ?? ''}
                                        onChange={(e) => {
                                          const newVal = e.target.value;
                                          const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                          newChildren[idx] = {
                                            ...newChildren[idx],
                                            [sub.p_name]: {
                                              ...newChildren[idx]?.[sub.p_name],
                                              desValue: newVal,
                                            },
                                          };
                                          setLocalParamValues((prev: any) => ({
                                            ...prev,
                                            [item.p_name]: {
                                              ...prev[item.p_name],
                                              p_children: newChildren,
                                            },
                                          }));
                                        }}
                                        style={{ flex: 1,marginLeft:10 }}
                                      />
                                    ):null)}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                          }}
                        >
                          <div
                            style={{
                              width: "120px",
                              fontSize: 14,
                              fontWeight: "bold",
                              color: "#1b6ae7",
                            }}
                          >
                            {item.p_name}
                          </div>
                        </div>
                        {item.p_engName === "No" && (
                          <div>
                            {(localParamValues[item.p_name]?.p_children || []).map(
                              (child: any, idx: number) => (
                                <div
                                  key={idx}
                                  style={{
                                    border: "1px solid #BBB",
                                    padding: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                    <div style={{ flex: 1, fontSize: 14 }}>
                                      {child["流股"]?.value}
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ width: "100px", fontSize: 14 }}>出料位置</div>
                                    <Input
                                      value={
                                        child["出料位置"].value
                                          ? child["出料位置"].value
                                          : child["出料位置"].value === ""
                                          ? ""
                                          : 
                                          // ((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                          //     ?.find((c: any) => c.p_name === "出料位置")?.p_value)
                                          (
                                            (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["outputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                            ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              ?.find((c: any) => c.p_name === "出料位置")?.p_value))
                                      }
                                      onChange={(e) => 
                                      {
                                        const newVal = e.target.value;
                                        setLocalParamValues((prev) => {
                                          const current = prev[item.p_name];
                                          const newChildren = [...(current?.p_children || [])];
                                          newChildren[idx] = {
                                            ...newChildren[idx],
                                            ["出料位置"]: {
                                              ...newChildren[idx]["出料位置"],
                                              value: newVal,
                                            },
                                          };
                                          return {
                                            ...prev,
                                            [item.p_name]: {
                                              ...current,
                                              p_children: newChildren,
                                            },
                                          };
                                        });

                                        // let N = Number(localParamValues["塔板数"].value);
                                        // if (Number.isNaN(N))
                                        // {
                                        //   N = null;
                                        // }
                                        // let newValNum = Number(newVal);
                                        // if (Number.isNaN(newValNum))
                                        // {
                                        //   newValNum = null;
                                        // }
                                        // if(N && newValNum && newValNum<=N && newValNum>=1 && Number.isInteger(newValNum))
                                        // {
                                        //   //恢复状态
                                        //   let newErrorInputs = [...errorInputs];
                                        //   newErrorInputs = newErrorInputs.filter(i => i !== `${item.p_engName}_${idx}`)
                                        //   setErrorInputs(newErrorInputs);
                                        // }
                                        // else
                                        // {
                                        //   //error状态
                                        //   let newErrorInputs = [...errorInputs];
                                        //   newErrorInputs.push(`${item.p_engName}_${idx}`);
                                        //   setErrorInputs(newErrorInputs);
                                        // }

                                      }}
                                      style={{ flex: 1 }}
                                      status={errorInputs.includes(`${item.p_engName}_${idx}`)?"error":""}
                                    />
                                    {(designVisible?(
                                      <Input
                                        value={
                                          child["出料位置"]?.desValue
                                            ? child["出料位置"]?.desValue
                                            : child["出料位置"]?.desValue === ""
                                            ? ""
                                            : 
                                            // ((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                            //     ?.find((c: any) => c.p_name === "出料位置")?.p_value)
                                            (
                                              (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["outputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                              ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                ?.find((c: any) => c.p_name === "出料位置")?.p_value))
                                        }
                                        onChange={(e) => {
                                          const newVal = e.target.value;
                                          setLocalParamValues((prev) => {
                                            const current = prev[item.p_name];
                                            const newChildren = [...(current?.p_children || [])];
                                            newChildren[idx] = {
                                              ...newChildren[idx],
                                              ["出料位置"]: {
                                                ...newChildren[idx]["出料位置"],
                                                desValue: newVal,
                                              },
                                            };
                                            return {
                                              ...prev,
                                              [item.p_name]: {
                                                ...current,
                                                p_children: newChildren,
                                              },
                                            };
                                          });
                                        }}
                                        style={{ flex: 1,marginLeft:10 }}
                                      />
                                    ):null)}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                        {item.p_engName === "Ns" && (
                          <div>
                            {(localParamValues[item.p_name]?.p_children || []).map(
                              (child: any, idx: number) => (
                                <div
                                  key={idx}
                                  style={{
                                    border: "1px solid #BBB",
                                    padding: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                    <div style={{ flex: 1, fontSize: 14 }}>
                                      {child["流股"]?.value}
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ width: "100px", fontSize: 14 }}>进料位置</div>
                                    <Input
                                      value={
                                        child["进料位置"].value
                                          ? child["进料位置"].value
                                          : child["进料位置"].value === ""
                                          ? ""
                                          :
                                          // ((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                          //     ?.find((c: any) => c.p_name === "进料位置")?.p_value)
                                          (
                                            (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["inputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                            ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              ?.find((c: any) => c.p_name === "进料位置")?.p_value))
                                      }
                                      onChange={(e) => {
                                        const newVal = e.target.value;
                                        setLocalParamValues((prev) => {
                                          const current = prev[item.p_name];
                                          const newChildren = [...(current?.p_children || [])];
                                          newChildren[idx] = {
                                            ...newChildren[idx],
                                            ["进料位置"]: {
                                              ...newChildren[idx]["进料位置"],
                                              value: newVal,
                                            },
                                          };
                                          return {
                                            ...prev,
                                            [item.p_name]: {
                                              ...current,
                                              p_children: newChildren,
                                            },
                                          };
                                        });

                                        // let N = Number(localParamValues["塔板数"].value);
                                        // if (Number.isNaN(N))
                                        // {
                                        //   N = null;
                                        // }
                                        // let newValNum = Number(newVal);
                                        // if (Number.isNaN(newValNum))
                                        // {
                                        //   newValNum = null;
                                        // }
                                        // if(N && newValNum && newValNum<=N && newValNum>=1 && Number.isInteger(newValNum))
                                        // {
                                        //   //恢复状态
                                        //   let newErrorInputs = [...errorInputs];
                                        //   newErrorInputs = newErrorInputs.filter(i => i !== `${item.p_engName}_${idx}`)
                                        //   setErrorInputs(newErrorInputs);
                                        // }
                                        // else
                                        // {
                                        //   //error状态
                                        //   let newErrorInputs = [...errorInputs];
                                        //   newErrorInputs.push(`${item.p_engName}_${idx}`);
                                        //   setErrorInputs(newErrorInputs);
                                        // }
                                      }}
                                      style={{ flex: 1 }}
                                      status={errorInputs.includes(`${item.p_engName}_${idx}`)?"error":""}
                                    />
                                    {(designVisible?(
                                      <Input
                                        value={
                                          child["进料位置"]?.desValue
                                            ? child["进料位置"]?.desValue
                                            : child["进料位置"]?.desValue === ""
                                            ? ""
                                            : 
                                            // ((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                            //     ?.find((c: any) => c.p_name === "进料位置")?.p_value)
                                            (
                                              (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["inputStreams"]).findIndex(item=>item.name===(child["流股"]?.value??""))])
                                              ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                                ?.find((c: any) => c.p_name === "进料位置")?.p_value))
                                        }
                                        onChange={(e) => {
                                          const newVal = e.target.value;
                                          setLocalParamValues((prev) => {
                                            const current = prev[item.p_name];
                                            const newChildren = [...(current?.p_children || [])];
                                            newChildren[idx] = {
                                              ...newChildren[idx],
                                              ["进料位置"]: {
                                                ...newChildren[idx]["进料位置"],
                                                desValue: newVal,
                                              },
                                            };
                                            return {
                                              ...prev,
                                              [item.p_name]: {
                                                ...current,
                                                p_children: newChildren,
                                              },
                                            };
                                          });
                                        }}
                                        style={{ flex: 1,marginLeft:10 }}
                                      />
                                    ):null)}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                        {item.p_engName === "output_f" && (
                          <div>
                            {(localParamValues[item.p_name]?.p_children || []).map(
                              (child: any, idx: number) => (
                                <div
                                  key={idx}
                                  style={{
                                    border: "1px solid #BBB",
                                    padding: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                    <div style={{ flex: 1, fontSize: 14 }}>
                                      {child["流股"]?.value}
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ width: "100px", fontSize: 14 }}>输出流量</div>
                                    <Input
                                      // 输出流量不做默认值回填：空值保持为空，仅当有已保存值时展示
                                      value={child["输出流量"].value ?? ""}
                                      onChange={(e) => {
                                        const newVal = e.target.value;
                                        setLocalParamValues((prev) => {
                                          const current = prev[item.p_name];
                                          const newChildren = [...(current?.p_children || [])];
                                          newChildren[idx] = {
                                            ...newChildren[idx],
                                            ["输出流量"]: {
                                              ...newChildren[idx]["输出流量"],
                                              value: newVal,
                                            },
                                          };
                                          return {
                                            ...prev,
                                            [item.p_name]: {
                                              ...current,
                                              p_children: newChildren,
                                            },
                                          };
                                        });
                                      }}
                                      style={{ flex: 1 }}
                                    />
                                    {(designVisible?(
                                      <Input
                                        // 输出流量设计值同样不做默认值回填：空值保持为空
                                        value={child["输出流量"].desValue ?? ""}
                                        onChange={(e) => {
                                          const newVal = e.target.value;
                                          setLocalParamValues((prev) => {
                                            const current = prev[item.p_name];
                                            const newChildren = [...(current?.p_children || [])];
                                            newChildren[idx] = {
                                              ...newChildren[idx],
                                              ["输出流量"]: {
                                                ...newChildren[idx]["输出流量"],
                                                desValue: newVal,
                                              },
                                            };
                                            return {
                                              ...prev,
                                              [item.p_name]: {
                                                ...current,
                                                p_children: newChildren,
                                              },
                                            };
                                          });
                                        }}
                                        style={{ flex: 1,marginLeft:10 }}
                                      />
                                    ):null)}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                        {(item.p_engName === "cold_out_T" || item.p_engName === "hot_out_T") && (
                          <div>
                            {(localParamValues[item.p_name]?.p_children || []).map(
                              (child: any, idx: number) => (
                                <div
                                  key={idx}
                                  style={{
                                    border: "1px solid #BBB",
                                    padding: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                    <div style={{ flex: 1, fontSize: 14 }}>
                                      {child["流股"]?.value}
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ width: "100px", fontSize: 14 }}>出口温度</div>
                                    <Input
                                      value={
                                        child["出口温度"].value
                                          ? child["出口温度"].value
                                          : child["出口温度"].value === ""
                                          ? ""
                                          :
                                          (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                            ?.find((c: any) => c.p_name === "出口温度")?.p_value
                                      }
                                      onChange={(e) => {
                                        const newVal = e.target.value;
                                        setLocalParamValues((prev) => {
                                          const current = prev[item.p_name];
                                          const newChildren = [...(current?.p_children || [])];
                                          newChildren[idx] = {
                                            ...newChildren[idx],
                                            ["出口温度"]: {
                                              ...newChildren[idx]["出口温度"],
                                              value: newVal,
                                            },
                                          };
                                          return {
                                            ...prev,
                                            [item.p_name]: {
                                              ...current,
                                              p_children: newChildren,
                                            },
                                          };
                                        });
                                      }}
                                      style={{ flex: 1 }}
                                    />
                                    {(designVisible?(
                                      <Input
                                        value={
                                          child["出口温度"]?.desValue
                                            ? child["出口温度"]?.desValue
                                            : child["出口温度"]?.desValue === ""
                                            ? ""
                                            :
                                            (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              ?.find((c: any) => c.p_name === "出口温度")?.p_value
                                        }
                                        onChange={(e) => {
                                          const newVal = e.target.value;
                                          setLocalParamValues((prev) => {
                                            const current = prev[item.p_name];
                                            const newChildren = [...(current?.p_children || [])];
                                            newChildren[idx] = {
                                              ...newChildren[idx],
                                              ["出口温度"]: {
                                                ...newChildren[idx]["出口温度"],
                                                desValue: newVal,
                                              },
                                            };
                                            return {
                                              ...prev,
                                              [item.p_name]: {
                                                ...current,
                                                p_children: newChildren,
                                              },
                                            };
                                          });
                                        }}
                                        style={{ flex: 1,marginLeft:10 }}
                                      />
                                    ):null)}
                                    <Select
                                      value={child["出口温度"].unit}
                                      onChange={(selectedUnit) => 
                                      {
                                        const unitField = item.p_children.find(i=>i.p_unitField).p_unitField;
                                        let newValues = { ...localParamValues };
                                        if (unitField) 
                                        {
                                          const coldCurrent = localParamValues["冷流股出口温度"];
                                          const coldNewChildren = [...(coldCurrent?.p_children || [])];
                                          for(let i=0;i<coldNewChildren.length;i++)
                                          {
                                            coldNewChildren[i] = 
                                            {
                                              ...coldNewChildren[i],
                                              ["出口温度"]: {
                                                ...coldNewChildren[i]["出口温度"],
                                                unit: selectedUnit,
                                              },
                                            };
                                          }
                                          const hotCurrent = localParamValues["热流股出口温度"];
                                          const hotNewChildren = [...(hotCurrent?.p_children || [])];
                                          for(let i=0;i<hotNewChildren.length;i++)
                                          {
                                            hotNewChildren[i] = 
                                            {
                                              ...hotNewChildren[i],
                                              ["出口温度"]: {
                                                ...hotNewChildren[i]["出口温度"],
                                                unit: selectedUnit,
                                              },
                                            };
                                          }
                                          setLocalParamValues((prev: any) => ({
                                            ...prev,
                                            ["冷流股出口温度"]: {
                                              ...prev["冷流股出口温度"],
                                              p_children: coldNewChildren,
                                            },
                                            ["热流股出口温度"]: {
                                              ...prev["热流股出口温度"],
                                              p_children: hotNewChildren,
                                            },
                                          }));
                                        }
                                      }}
                                      style={{ marginLeft: "10px", width: "100px" }}
                                      options={unitMap[item.p_children.find(i=>i.p_type).p_type].map((unit: string) => ({ label: unit, value: unit }))}
                                    />
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                        {(item.p_engName === "cold_out_P" || item.p_engName === "hot_out_P") && (
                          <div>
                            {(localParamValues[item.p_name]?.p_children || []).map(
                              (child: any, idx: number) => (
                                <div
                                  key={idx}
                                  style={{
                                    border: "1px solid #BBB",
                                    padding: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ width: "100px", fontSize: 14 }}>流股</div>
                                    <div style={{ flex: 1, fontSize: 14 }}>
                                      {child["流股"]?.value}
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ width: "100px", fontSize: 14 }}>出口压力</div>
                                    <Input
                                      value={
                                        child["出口压力"].value
                                          ? child["出口压力"].value
                                          : child["出口压力"].value === ""
                                          ? ""
                                          :
                                          (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                            ?.find((c: any) => c.p_name === "出口压力")?.p_value
                                      }
                                      onChange={(e) => {
                                        const newVal = e.target.value;
                                        setLocalParamValues((prev) => {
                                          const current = prev[item.p_name];
                                          const newChildren = [...(current?.p_children || [])];
                                          newChildren[idx] = {
                                            ...newChildren[idx],
                                            ["出口压力"]: {
                                              ...newChildren[idx]["出口压力"],
                                              value: newVal,
                                            },
                                          };
                                          return {
                                            ...prev,
                                            [item.p_name]: {
                                              ...current,
                                              p_children: newChildren,
                                            },
                                          };
                                        });
                                      }}
                                      style={{ flex: 1 }}
                                    />
                                    {(designVisible?(
                                      <Input
                                        value={
                                          child["出口压力"]?.desValue
                                            ? child["出口压力"]?.desValue
                                            : child["出口压力"]?.desValue === ""
                                            ? ""
                                            :
                                            (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              ?.find((c: any) => c.p_name === "出口压力")?.p_value
                                        }
                                        onChange={(e) => {
                                          const newVal = e.target.value;
                                          setLocalParamValues((prev) => {
                                            const current = prev[item.p_name];
                                            const newChildren = [...(current?.p_children || [])];
                                            newChildren[idx] = {
                                              ...newChildren[idx],
                                              ["出口压力"]: {
                                                ...newChildren[idx]["出口压力"],
                                                desValue: newVal,
                                              },
                                            };
                                            return {
                                              ...prev,
                                              [item.p_name]: {
                                                ...current,
                                                p_children: newChildren,
                                              },
                                            };
                                          });
                                        }}
                                        style={{ flex: 1,marginLeft:10 }}
                                      />
                                    ):null)}
                                    <Select
                                      value={child["出口压力"].unit}
                                      onChange={(selectedUnit) => 
                                      {
                                        const unitField = item.p_children.find(i=>i.p_unitField).p_unitField;
                                        let newValues = { ...localParamValues };
                                        if (unitField) 
                                        {
                                          const coldCurrent = localParamValues["冷流股出口压力"];
                                          const coldNewChildren = [...(coldCurrent?.p_children || [])];
                                          for(let i=0;i<coldNewChildren.length;i++)
                                          {
                                            coldNewChildren[i] = 
                                            {
                                              ...coldNewChildren[i],
                                              ["出口压力"]: {
                                                ...coldNewChildren[i]["出口压力"],
                                                unit: selectedUnit,
                                              },
                                            };
                                          }
                                          const hotCurrent = localParamValues["热流股出口压力"];
                                          const hotNewChildren = [...(hotCurrent?.p_children || [])];
                                          for(let i=0;i<hotNewChildren.length;i++)
                                          {
                                            hotNewChildren[i] = 
                                            {
                                              ...hotNewChildren[i],
                                              ["出口压力"]: {
                                                ...hotNewChildren[i]["出口压力"],
                                                unit: selectedUnit,
                                              },
                                            };
                                          }
                                          setLocalParamValues((prev: any) => ({
                                            ...prev,
                                            ["冷流股出口压力"]: {
                                              ...prev["冷流股出口压力"],
                                              p_children: coldNewChildren,
                                            },
                                            ["热流股出口压力"]: {
                                              ...prev["热流股出口压力"],
                                              p_children: hotNewChildren,
                                            },
                                          }));
                                        }
                                      }}
                                      style={{ marginLeft: "10px", width: "100px" }}
                                      options={unitMap[item.p_children.find(i=>i.p_type).p_type].map((unit: string) => ({ label: unit, value: unit }))}
                                    />
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                        {item.p_engName === "stream_type" && (
                          <div>
                            {(localParamValues[item.p_name]?.p_children || []).map((child: any, idx: number) => (
                              <div
                                key={idx}
                                style={{
                                  border: "1px solid #BBB",
                                  padding: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                {item.p_children.map((sub: any) => (
                                  <div
                                    key={sub.p_name}
                                    style={{display:sub.p_show||child[sub.p_name]?.show?"flex":"none",alignItems:child[sub.p_name]?.children?"stretch":"center",marginTop:child[sub.p_name]?.children?15:0,marginBottom: "10px"}}
                                  >
                                    <div style={{ width: "100px", fontSize: 14 }}>{sub.p_name}</div>
                                    {sub.p_children ? (
                                      <div style={{ flex: 1 }}>
                                        {(child[sub.p_name].children || []).map((child2,idx2) => (
                                          <div key={idx2} style={{border: '1px solid #BBB',marginBottom:10,padding:10}}>
                                            {sub.p_children.map((field) => (
                                              <div
                                                key={field.p_name}
                                                style={{ display:'flex',alignItems:'center',marginBottom:10}}
                                              >
                                                <div style={{ width:80,fontSize:14}}>{field.p_name}</div>
                                                {child2[field.p_name].readonly ? (
                                                  <div style={{ flex: 1,fontSize:14 }}>{child2[field.p_name].value??''}</div>
                                                ) : (
                                                  <div style={{ flex: 1,display:"flex",flexDirection:"row"}}>
                                                    <Input
                                                      value={child2[field.p_name].value ?? ''}
                                                      onChange={(e) => 
                                                      {
                                                        const newVal = e.target.value;
                                                        // 更新 specChild 中对应字段的值
                                                        const newSpecChildren = [...(child[sub.p_name]?.children || [])];
                                                        newSpecChildren[idx2] = {
                                                          ...newSpecChildren[idx2],
                                                          [field.p_name]: {
                                                            ...newSpecChildren[idx2][field.p_name],
                                                            value: newVal,
                                                          },
                                                        };
                                                        const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                        newChildren[idx] = {
                                                          ...child,
                                                          [sub.p_name]: {
                                                            ...child[sub.p_name],
                                                            children: newSpecChildren,
                                                          },
                                                        };
                                                        setLocalParamValues((prev: any) => ({
                                                          ...prev,
                                                          [item.p_name]: {
                                                            ...prev[item.p_name],
                                                            p_children: newChildren,
                                                          },
                                                        }));
                                                      }}
                                                      style={{ flex: 1 }}
                                                    />
                                                    {(designVisible?(
                                                      <Input
                                                        value={child2[field.p_name].desValue ?? ''}
                                                        onChange={(e) => 
                                                        {
                                                          const newVal = e.target.value;
                                                          // 更新 specChild 中对应字段的值
                                                          const newSpecChildren = [...(child[sub.p_name]?.children || [])];
                                                          newSpecChildren[idx2] = {
                                                            ...newSpecChildren[idx2],
                                                            [field.p_name]: {
                                                              ...newSpecChildren[idx2][field.p_name],
                                                              desValue: newVal,
                                                            },
                                                          };
                                                          const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                                          newChildren[idx] = {
                                                            ...child,
                                                            [sub.p_name]: {
                                                              ...child[sub.p_name],
                                                              children: newSpecChildren,
                                                            },
                                                          };
                                                          setLocalParamValues((prev: any) => ({
                                                            ...prev,
                                                            [item.p_name]: {
                                                              ...prev[item.p_name],
                                                              p_children: newChildren,
                                                            },
                                                          }));
                                                        }}
                                                        style={{ flex: 1,marginLeft:10 }}
                                                      />
                                                    ):null)}
                                                  </div>
                                                )}
                                              </div>
                                            ))}
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div style={{flex:1,display:"flex",flexDirection:"row"}}>
                                        <Input
                                          value={child[sub.p_name]?.value ?? ''}
                                          onChange={(e) => {
                                            const newVal = e.target.value;
                                            const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                            newChildren[idx] = {
                                              ...newChildren[idx],
                                              [sub.p_name]: {
                                                ...newChildren[idx]?.[sub.p_name],
                                                value: newVal,
                                              },
                                            };
                                            setLocalParamValues((prev: any) => ({
                                              ...prev,
                                              [item.p_name]: {
                                                ...prev[item.p_name],
                                                p_children: newChildren,
                                              },
                                            }));
                                          }}
                                          style={{ flex: 1 }}
                                        />
                                        {(designVisible?(
                                          <Input
                                            value={child[sub.p_name]?.desValue ?? ''}
                                            onChange={(e) => {
                                              const newVal = e.target.value;
                                              const newChildren = [...(localParamValues[item.p_name]?.p_children || [])];
                                              newChildren[idx] = {
                                                ...newChildren[idx],
                                                [sub.p_name]: {
                                                  ...newChildren[idx]?.[sub.p_name],
                                                  desValue: newVal,
                                                },
                                              };
                                              setLocalParamValues((prev: any) => ({
                                                ...prev,
                                                [item.p_name]: {
                                                  ...prev[item.p_name],
                                                  p_children: newChildren,
                                                },
                                              }));
                                            }}
                                            style={{ flex: 1,marginLeft:10 }}
                                          />
                                        ):null)}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        )}
                        {item.p_engName === "streamRelationship" && (
                          <div>
                            {(localParamValues[item.p_name]?.p_children || []).map(
                              (child: any, idx: number) => (
                                <div
                                  key={idx}
                                  style={{
                                    border: "1px solid #BBB",
                                    padding: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={{ width: "100px", fontSize: 14 }}>出口流股</div>
                                    <div style={{ flex: 1, fontSize: 14 }}>
                                      {child["出口流股"]?.value}
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ width: "100px", fontSize: 14 }}>入口流股</div>
                                    <Select
                                      value={
                                        child["入口流股"].value
                                          ? child["入口流股"].value
                                          : child["入口流股"].value === ""
                                          ? ""
                                          :
                                          // (modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                          //   ?.find((c: any) => c.p_name === "入口流股")?.p_value
                                          (
                                            (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.["outputStreams"]).findIndex(item=>item.name===(child["出口流股"]?.value??""))])
                                            ??((modalParams.find(m => m.p_name === item.p_name)?.p_children)
                                              ?.find((c: any) => c.p_name === "入口流股")?.p_value))
                                      }
                                      onChange={(selectedValue) => 
                                      {
                                        setLocalParamValues((prev) => {
                                          const current = prev[item.p_name];
                                          const newChildren = [...(current?.p_children || [])];
                                          newChildren[idx] = {
                                            ...newChildren[idx],
                                            ["入口流股"]: {
                                              ...newChildren[idx]["入口流股"],
                                              value: selectedValue,
                                            },
                                          };
                                          return {
                                            ...prev,
                                            [item.p_name]: {
                                              ...current,
                                              p_children: newChildren,
                                            },
                                          };
                                        });
                                      }}
                                      style={{ flex: 1 }}
                                      options={child["入口流股"].enum.map((opt: any) => ({ label: opt.label, value: opt.value }))}
                                    />
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <div style={{ width: "120px", fontSize: 14 }}>{item?.p_name}</div>
                    {item.enum && Array.isArray(item.enum) && item.enum.length > 0 ? (
                      <Select
                        value={localParamValues[item?.p_name]?.value}
                        onChange={(selectedValue) => 
                        {
                          //特殊处理
                          if(item?.p_name==="流股属性" && localParamValues["冷流股出口温度"] && localParamValues["热流股出口温度"] && localParamValues["冷流股出口压力"] && localParamValues["热流股出口压力"])
                          {
                            if(selectedValue==="冷流股")
                            {
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue:selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["冷流股出口温度"]:{
                                  ...prev["冷流股出口温度"],
                                  show:true,
                                },
                                ["热流股出口温度"]:{
                                  ...prev["热流股出口温度"],
                                  show:false,
                                },
                                ["冷流股出口压力"]:{
                                  ...prev["冷流股出口压力"],
                                  show:true,
                                },
                                ["热流股出口压力"]:{
                                  ...prev["热流股出口压力"],
                                  show:false,
                                },
                              }));
                            }
                            else if(selectedValue==="热流股")
                            {
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue: selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["冷流股出口温度"]:{
                                  ...prev["冷流股出口温度"],
                                  show:false,
                                },
                                ["热流股出口温度"]:{
                                  ...prev["热流股出口温度"],
                                  show:true,
                                },
                                ["冷流股出口压力"]:{
                                  ...prev["冷流股出口压力"],
                                  show:false,
                                },
                                ["热流股出口压力"]:{
                                  ...prev["热流股出口压力"],
                                  show:true,
                                },
                              }));
                            }
                          }
                          else if(item?.p_name==="流股属性" && localParamValues["冷流出口温度"] && localParamValues["热流出口温度"] && localParamValues["冷流出口压力"] && localParamValues["热流出口压力"])
                          {
                            if(selectedValue==="冷流股")
                            {
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue:selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["冷流出口温度"]:{
                                  ...prev["冷流出口温度"],
                                  show:true,
                                },
                                ["热流出口温度"]:{
                                  ...prev["热流出口温度"],
                                  show:false,
                                },
                                ["冷流出口压力"]:{
                                  ...prev["冷流出口压力"],
                                  show:true,
                                },
                                ["热流出口压力"]:{
                                  ...prev["热流出口压力"],
                                  show:false,
                                },
                              }));
                            }
                            else if(selectedValue==="热流股")
                            {
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue: selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["冷流出口温度"]:{
                                  ...prev["冷流出口温度"],
                                  show:false,
                                },
                                ["热流出口温度"]:{
                                  ...prev["热流出口温度"],
                                  show:true,
                                },
                                ["冷流出口压力"]:{
                                  ...prev["冷流出口压力"],
                                  show:false,
                                },
                                ["热流出口压力"]:{
                                  ...prev["热流出口压力"],
                                  show:true,
                                },
                              }));
                            }
                          }
                          else if(item?.p_name==="内部类型" && localParamValues["塔盘类型"] && localParamValues["填料类型"] && localParamValues["塔板数"] && localParamValues["有效孔面积比"] && localParamValues["堰高"] && localParamValues["塔板材质"] && localParamValues["溢流类型"] && localParamValues["填料高度"])
                          {
                            if(selectedValue==="塔板")
                            {
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue:selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["塔盘类型"]:{
                                  ...prev["塔盘类型"],
                                  show:true,
                                },
                                ["塔板数"]:{
                                  ...prev["塔板数"],
                                  show:true,
                                },
                                ["有效孔面积比"]:{
                                  ...prev["有效孔面积比"],
                                  show:true,
                                },
                                ["堰高"]:{
                                  ...prev["堰高"],
                                  show:true,
                                },
                                ["塔板材质"]:{
                                  ...prev["塔板材质"],
                                  show:true,
                                },
                                ["溢流类型"]:{
                                  ...prev["溢流类型"],
                                  show:true,
                                },

                                ["填料类型"]:{
                                  ...prev["填料类型"],
                                  show:false,
                                },
                                ["填料高度"]:{
                                  ...prev["填料高度"],
                                  show:false,
                                }
                              }));
                            }
                            else if(selectedValue==="填料")
                            {
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue: selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["塔盘类型"]:{
                                  ...prev["塔盘类型"],
                                  show:false,
                                },
                                // ["塔板数"]:{
                                //   ...prev["塔板数"],
                                //   show:false,
                                // },
                                ["有效孔面积比"]:{
                                  ...prev["有效孔面积比"],
                                  show:false,
                                },
                                ["堰高"]:{
                                  ...prev["堰高"],
                                  show:false,
                                },
                                ["塔板材质"]:{
                                  ...prev["塔板材质"],
                                  show:false,
                                },
                                ["溢流类型"]:{
                                  ...prev["溢流类型"],
                                  show:false,
                                },


                                ["填料类型"]:{
                                  ...prev["填料类型"],
                                  show:true,
                                },
                                ["填料高度"]:{
                                  ...prev["填料高度"],
                                  show:true,
                                }
                              }));
                            }
                            else if(selectedValue==="混合")
                            {
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue: selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["塔盘类型"]:{
                                  ...prev["塔盘类型"],
                                  show:true,
                                },
                                ["塔板数"]:{
                                  ...prev["塔板数"],
                                  show:true,
                                },
                                ["有效孔面积比"]:{
                                  ...prev["有效孔面积比"],
                                  show:true,
                                },
                                ["堰高"]:{
                                  ...prev["堰高"],
                                  show:true,
                                },
                                ["塔板材质"]:{
                                  ...prev["塔板材质"],
                                  show:true,
                                },
                                ["溢流类型"]:{
                                  ...prev["溢流类型"],
                                  show:true,
                                },

                                ["填料类型"]:{
                                  ...prev["填料类型"],
                                  show:true,
                                },
                                ["填料高度"]:{
                                  ...prev["填料高度"],
                                  show:true,
                                }
                              }));
                            }
                          }
                          else if(item?.p_name==="操作规范" && localParamValues["操作规范值"])
                          {
                            if(selectedValue==="塔底物流率")
                            {
                              let newUnits = ["kmol/hr","kg/hr","cum/hr"];
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue:selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["操作规范值"]:{
                                  ...prev["操作规范值"],
                                  unit:newUnits[0],
                                }
                              }));
                            }
                            else if(selectedValue==="再沸器负荷")
                            {
                              let newUnits = ["Gcal/hr","kW"];
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  value: selectedValue,
                                  desValue:selectedValue,
                                  show: item.p_show ?? false,
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                                ["操作规范值"]:{
                                  ...prev["操作规范值"],
                                  unit:newUnits[0],
                                }
                              }));
                            }
                          }
                          else
                          {
                            setLocalParamValues((prev) => ({
                              ...prev,
                              [item?.p_name]: {
                                value: selectedValue,
                                desValue: selectedValue,
                                show: localParamValues[item?.p_name].show??(item.p_show ?? false),
                                engName: item.p_engName ?? "",
                                unitField: item.p_unitField ?? null,
                              },
                            }));
                          }
                        }}
                        style={{ flex: 1 }}
                        options={item.enum.map((opt: any) => ({ label: opt.label, value: opt.value }))}
                      />
                    ) : (
                      <>
                        {item?.p_name!=="说明文本" ? (<Input
                          value={
                            localParamValues[item?.p_name]?.value ??
                            // modalParams.find((m: any) => m.p_name === item.p_name)?.p_value
                            ( (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]) 
                            ?? modalParams.find((m: any) => m.p_name === item.p_name)?.p_value)
                          }
                          onChange={(e) => {
                            setLocalParamValues((prev) => ({
                              ...prev,
                              [item?.p_name]: {
                                ...prev[item?.p_name],
                                value: e.target.value,
                                show: localParamValues[item.p_name].show??(item.p_show ?? false),
                                engName: item.p_engName ?? "",
                                unitField: item.p_unitField ?? null,
                              },
                            }));

                            // //特殊处理
                            // if(item.p_engName==="N")
                            // {
                            //   let N = Number(e.target.value);
                            //   if (Number.isNaN(N))
                            //   {
                            //     N = null;
                            //   }
                            //   let Nos = localParamValues["出料流股位置"].p_children;
                            //   let Nss = localParamValues["进料流股位置"].p_children;
                            //   let NoValues = Nos.map(obj => obj["出料位置"].value);
                            //   let NsValues = Nss.map(obj => obj["进料位置"].value);
                              
                            //   if(N && N>=1 && Number.isInteger(N))
                            //   {
                            //     //恢复状态
                            //     let newErrorInputs = [...errorInputs];
                            //     newErrorInputs = newErrorInputs.filter(i => i !== item.p_engName);

                            //     //判断No与Ns的值
                            //     for(let i=0;i<NoValues.length;i++)
                            //     {
                            //       let value = Number(NoValues[i]);
                            //       if (Number.isNaN(value))
                            //       {
                            //         value = null;
                            //       }
                            //       if(value && value<=N && value>=1 && Number.isInteger(value))
                            //       {
                            //         newErrorInputs = newErrorInputs.filter(j => j !== `No_${i}`);
                            //       }
                            //       else
                            //       {
                            //         newErrorInputs.push(`No_${i}`);
                            //       }
                            //     }
                            //     for(let i=0;i<NsValues.length;i++)
                            //     {
                            //       let value = Number(NsValues[i]);
                            //       if (Number.isNaN(value))
                            //       {
                            //         value = null;
                            //       }
                            //       if(value && value<=N && value>=1 && Number.isInteger(value))
                            //       {
                            //         newErrorInputs = newErrorInputs.filter(j => j !== `Ns_${i}`);
                            //       }
                            //       else
                            //       {
                            //         newErrorInputs.push(`Ns_${i}`);
                            //       }
                            //     }

                            //     setErrorInputs(newErrorInputs);
                            //   }
                            //   else
                            //   {
                            //     //error状态
                            //     let newErrorInputs = [...errorInputs];
                            //     newErrorInputs.push(item.p_engName);

                            //     //如果N有误，则No与Ns都有误
                            //     for(let i=0;i<NoValues.length;i++)
                            //     {
                            //       newErrorInputs.push(`No_${i}`);
                            //     }
                            //     for(let i=0;i<NsValues.length;i++)
                            //     {
                            //       newErrorInputs.push(`Ns_${i}`);
                            //     }

                            //     setErrorInputs(newErrorInputs);
                            //   }
                            // }

                          }}
                          style={{ flex: 1 }}
                          status={errorInputs.includes(item.p_engName)?"error":""}
                        />):(
                          <Input.TextArea
                            autoSize={{maxRows:undefined}}
                            value={localParamValues[item?.p_name]?.value ?? modalParams.find((m: any) => m.p_name === item.p_name)?.p_value}
                            onChange={(e) => 
                            {
                              setLocalParamValues((prev) => 
                              ({
                                ...prev,
                                [item?.p_name]: {
                                  ...prev[item?.p_name],
                                  value: e.target.value,
                                  show: localParamValues[item.p_name].show??(item.p_show ?? false),
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                              }));
                            }}
                            style={{ flex: 1,minHeight:200,maxHeight:200}}
                          />
                        )}
                        
                        {designVisible ? (
                          <Input
                            value={
                              localParamValues[item?.p_name]?.desValue ??
                              // modalParams.find((m: any) => m.p_name === item.p_name)?.p_value
                              ( (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]) 
                              ?? modalParams.find((m: any) => m.p_name === item.p_name)?.p_value)
                            }
                            onChange={(e) => {
                              setLocalParamValues((prev) => ({
                                ...prev,
                                [item?.p_name]: {
                                  ...prev[item?.p_name],
                                  desValue: e.target.value,
                                  show: localParamValues[item.p_name].show??(item.p_show ?? false),
                                  engName: item.p_engName ?? "",
                                  unitField: item.p_unitField ?? null,
                                },
                              }));
                            }}
                            style={{ flex: 1,marginLeft:10 }}
                          />
                        ):null}
                        {item.p_unit && Array.isArray(item.p_unit) && item.p_unit.length > 0 ? (
                          <Select
                            value={localParamValues[item?.p_name]?.unit}
                            onChange={(selectedUnit) => {
                              const unitField = item.p_unitField;
                              let newValues = { ...localParamValues };
                              if (unitField) {
                                const sameFieldParams = modalParams
                                  .filter((p: any) => p.p_unitField === unitField)
                                  .map((p: any) => p.p_name);
                                sameFieldParams.forEach((paramName: string) => {
                                  newValues[paramName] = {
                                    ...newValues[paramName],
                                    unit: selectedUnit,
                                  };
                                });
                              } else {
                                newValues[item.p_name] = {
                                  ...newValues[item.p_name],
                                  unit: selectedUnit,
                                };
                              }
                              setLocalParamValues(newValues);
                            }}
                            style={{ marginLeft: "10px", width: "100px" }}
                            //特殊处理
                            options={item.p_engName!=="operatingSpecificationsValue" ? (item.p_unit.map((unit: string) => ({ label: unit, value: unit }))) : 
                              item.p_engName==="operatingSpecificationsValue" ? 
                              (localParamValues[item.p_name]?.unit==="kmol/hr"||localParamValues[item.p_name]?.unit==="kg/hr"||localParamValues[item.p_name]?.unit==="cum/hr" ? (item.p_unit_1.map((unit: string) => ({ label: unit, value: unit }))) : (localParamValues[item.p_name]?.unit==="Gcal/hr"||localParamValues[item.p_name]?.unit==="kW" ? (item.p_unit_2.map((unit: string) => ({ label: unit, value: unit }))) : (item.p_unit.map((unit: string) => ({ label: unit, value: unit }))) ) )
                              : (item.p_unit.map((unit: string) => ({ label: unit, value: unit })))
                            }
                          />
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </div>
            ))}
          
          {/* 分类参数区域 */}
          {modalParams &&
            Array.isArray(modalParams) &&
            modalParams.filter(item=>item.p_class).length>0 &&
            (Array.from(new Set(modalParams.filter(item => item.p_class).map(obj => obj["p_class"])))).map((fieldClassName) => 
            {
              const itemsInCategory = modalParams.filter(item => item.p_class === fieldClassName);
              // 判断是否有任意一项需要显示
              const hasAnyShow = itemsInCategory.some(item => localParamValues[item.p_name]?.show === true);

              return (
                <div style={{display:hasAnyShow ?"flex":"none",flexDirection:"column" }}>
                  <div style={{fontSize: 14,fontWeight: "bold",color: "#1b6ae7",marginBottom:10}}>
                    {fieldClassName}
                  </div>
                  <div style={{border:"1px solid #BBB",marginBottom:20,paddingLeft:10,paddingRight:10,paddingTop:10}}>
                    {modalParams &&
                      Array.isArray(modalParams) &&
                      modalParams.filter(item=>item.p_class===fieldClassName).map((item) => (
                        <div
                          key={item?.p_name}
                          style={{
                            display: item.p_show||localParamValues[item.p_name]?.show ? "flex" : "none",
                            flexDirection: "row",
                            alignItems: "center",
                            marginBottom: item.p_show||localParamValues[item.p_name]?.show ? "10px" : "0px",
                          }}
                        >
                          {/* 有 p_children 的情况 */}
                          {item.p_children && Array.isArray(item.p_children) && item.p_children.length > 0 ? (
                            <div style={{ width: "100%", marginBottom: "10px" }}>
                              {/* 暂不考虑p_children情况 */}
                            </div>
                          ) : (
                            <>
                              <div style={{ width: "120px", fontSize: 14 }}>{item?.p_name}</div>
                              {item.enum && Array.isArray(item.enum) && item.enum.length > 0 ? (
                                <Select
                                  value={localParamValues[item?.p_name]?.value}
                                  onChange={(selectedValue) => 
                                  {
                                    //特殊处理
                                    if(item?.p_name==="内部类型" && localParamValues["塔盘类型"] && localParamValues["填料类型"] && localParamValues["塔板数"] && localParamValues["有效孔面积比"] && localParamValues["堰高"] && localParamValues["塔板材质"] && localParamValues["溢流类型"] && localParamValues["填料高度"])
                                    {
                                      if(selectedValue==="塔板")
                                      {
                                        setLocalParamValues((prev) => ({
                                          ...prev,
                                          [item?.p_name]: {
                                            value: selectedValue,
                                            desValue:selectedValue,
                                            show: item.p_show ?? false,
                                            engName: item.p_engName ?? "",
                                            unitField: item.p_unitField ?? null,
                                          },
                                          ["塔盘类型"]:{
                                            ...prev["塔盘类型"],
                                            show:true,
                                          },
                                          // ["塔板数"]:{
                                          //   ...prev["塔板数"],
                                          //   show:true,
                                          // },
                                          ["有效孔面积比"]:{
                                            ...prev["有效孔面积比"],
                                            show:true,
                                          },
                                          ["堰高"]:{
                                            ...prev["堰高"],
                                            show:true,
                                          },
                                          ["塔板材质"]:{
                                            ...prev["塔板材质"],
                                            show:true,
                                          },
                                          ["溢流类型"]:{
                                            ...prev["溢流类型"],
                                            show:true,
                                          },

                                          ["填料类型"]:{
                                            ...prev["填料类型"],
                                            show:false,
                                          },
                                          ["填料高度"]:{
                                            ...prev["填料高度"],
                                            show:false,
                                          }
                                        }));
                                      }
                                      else if(selectedValue==="填料")
                                      {
                                        setLocalParamValues((prev) => ({
                                          ...prev,
                                          [item?.p_name]: {
                                            value: selectedValue,
                                            desValue: selectedValue,
                                            show: item.p_show ?? false,
                                            engName: item.p_engName ?? "",
                                            unitField: item.p_unitField ?? null,
                                          },
                                          ["塔盘类型"]:{
                                            ...prev["塔盘类型"],
                                            show:false,
                                          },
                                          // ["塔板数"]:{
                                          //   ...prev["塔板数"],
                                          //   show:false,
                                          // },
                                          ["有效孔面积比"]:{
                                            ...prev["有效孔面积比"],
                                            show:false,
                                          },
                                          ["堰高"]:{
                                            ...prev["堰高"],
                                            show:false,
                                          },
                                          ["塔板材质"]:{
                                            ...prev["塔板材质"],
                                            show:false,
                                          },
                                          ["溢流类型"]:{
                                            ...prev["溢流类型"],
                                            show:false,
                                          },


                                          ["填料类型"]:{
                                            ...prev["填料类型"],
                                            show:true,
                                          },
                                          ["填料高度"]:{
                                            ...prev["填料高度"],
                                            show:true,
                                          }
                                        }));
                                      }
                                      else if(selectedValue==="混合")
                                      {
                                        setLocalParamValues((prev) => ({
                                          ...prev,
                                          [item?.p_name]: {
                                            value: selectedValue,
                                            desValue: selectedValue,
                                            show: item.p_show ?? false,
                                            engName: item.p_engName ?? "",
                                            unitField: item.p_unitField ?? null,
                                          },
                                          ["塔盘类型"]:{
                                            ...prev["塔盘类型"],
                                            show:true,
                                          },
                                          // ["塔板数"]:{
                                          //   ...prev["塔板数"],
                                          //   show:true,
                                          // },
                                          ["有效孔面积比"]:{
                                            ...prev["有效孔面积比"],
                                            show:true,
                                          },
                                          ["堰高"]:{
                                            ...prev["堰高"],
                                            show:true,
                                          },
                                          ["塔板材质"]:{
                                            ...prev["塔板材质"],
                                            show:true,
                                          },
                                          ["溢流类型"]:{
                                            ...prev["溢流类型"],
                                            show:true,
                                          },

                                          ["填料类型"]:{
                                            ...prev["填料类型"],
                                            show:true,
                                          },
                                          ["填料高度"]:{
                                            ...prev["填料高度"],
                                            show:true,
                                          }
                                        }));
                                      }
                                    }
                                    else
                                    {
                                      setLocalParamValues((prev) => ({
                                        ...prev,
                                        [item?.p_name]: {
                                          value: selectedValue,
                                          desValue: selectedValue,
                                          show: localParamValues[item?.p_name].show??(item.p_show ?? false),
                                          engName: item.p_engName ?? "",
                                          unitField: item.p_unitField ?? null,
                                        },
                                      }));
                                    }
                                  }}
                                  style={{ flex: 1 }}
                                  options={item.enum.map((opt: any) => ({ label: opt.label, value: opt.value }))}
                                />
                              ) : (
                                <>
                                  {item?.p_name!=="说明文本" ? (<Input
                                    value={
                                      localParamValues[item?.p_name]?.value ??
                                      // modalParams.find((m: any) => m.p_name === item.p_name)?.p_value
                                      ( (localFormData?.["元件名称"]?.value && test_Rectisol.inputs.elements.find(item=>item.name===localFormData?.["元件名称"]?.value)?.params[item.p_engName]) 
                                      ?? modalParams.find((m: any) => m.p_name === item.p_name)?.p_value)
                                    }
                                    onChange={(e) => {
                                      setLocalParamValues((prev) => ({
                                        ...prev,
                                        [item?.p_name]: {
                                          ...prev[item?.p_name],
                                          value: e.target.value,
                                          show: localParamValues[item.p_name].show??(item.p_show ?? false),
                                          engName: item.p_engName ?? "",
                                          unitField: item.p_unitField ?? null,
                                        },
                                      }));

                                    }}
                                    style={{ flex: 1 }}
                                    status={errorInputs.includes(item.p_engName)?"error":""}
                                  />):(
                                    <div>
                                      {/* 暂不考虑说明文本情况 */}
                                    </div>
                                  )}
                                  {item.p_unit && Array.isArray(item.p_unit) && item.p_unit.length > 0 ? (
                                    <Select
                                      value={localParamValues[item?.p_name]?.unit}
                                      onChange={(selectedUnit) => {
                                        const unitField = item.p_unitField;
                                        let newValues = { ...localParamValues };
                                        if (unitField) {
                                          const sameFieldParams = modalParams
                                            .filter((p: any) => p.p_unitField === unitField)
                                            .map((p: any) => p.p_name);
                                          sameFieldParams.forEach((paramName: string) => {
                                            newValues[paramName] = {
                                              ...newValues[paramName],
                                              unit: selectedUnit,
                                            };
                                          });
                                        } else {
                                          newValues[item.p_name] = {
                                            ...newValues[item.p_name],
                                            unit: selectedUnit,
                                          };
                                        }
                                        setLocalParamValues(newValues);
                                      }}
                                      style={{ marginLeft: "10px", width: "100px" }}
                                      //特殊处理
                                      options={item.p_engName!=="operatingSpecificationsValue" ? (item.p_unit.map((unit: string) => ({ label: unit, value: unit }))) : 
                                        item.p_engName==="operatingSpecificationsValue" ? 
                                        (localParamValues[item.p_name]?.unit==="kmol/hr"||localParamValues[item.p_name]?.unit==="kg/hr"||localParamValues[item.p_name]?.unit==="cum/hr" ? (item.p_unit_1.map((unit: string) => ({ label: unit, value: unit }))) : (localParamValues[item.p_name]?.unit==="Gcal/hr"||localParamValues[item.p_name]?.unit==="kW" ? (item.p_unit_2.map((unit: string) => ({ label: unit, value: unit }))) : (item.p_unit.map((unit: string) => ({ label: unit, value: unit }))) ) )
                                        : (item.p_unit.map((unit: string) => ({ label: unit, value: unit })))
                                      }
                                    />
                                  ) : null}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              )
            }
          )}

          {/* 流股组分区域 */}
          {materialsData &&
            typeof materialsData === "object" &&
            !Array.isArray(materialsData) &&
            localFormData["流股名称"] &&
            globalData &&
            globalData.materials &&
            globalData.materials.length > 0 && (
              <div style={{display:"flex",flexDirection:"row",alignItems: "center",marginBottom:10}}>
                <div
                  style={{
                    width: "120px",
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "#1b6ae7",
                  }}
                >
                  组分摩尔分率
                </div>
                <Button type="text" style={{height: 30,width: 30,borderRadius: 50,backgroundColor: "#FFF",marginLeft: "auto"}}
                  onClick={() =>{setModalVariable(true);}}
                >
                  <CopyOutlined style={{ fontSize: 18, color: "#1b6ae7" }} />
                </Button>
              </div>
            )}
          {materialsData &&
            typeof materialsData === "object" &&
            !Array.isArray(materialsData) &&
            localFormData["流股名称"] &&
            globalData &&
            globalData.materials &&
            globalData.materials.map((item: any) => (
              <div
                key={item.formula}
                style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}
              >
                <div
                  style={{ width: "120px", fontSize: 14 }}
                >{`${rebuildFormula(item.formula)}（${item.name}）`}</div>
                <Input
                  value={localMaterialsData[item.formula]?.molar_frac ?? (localMaterialsData[item.formula].molar_frac===0 ? (localMaterialsData[item.formula].molar_frac): "")}
                  onChange={(e) => {
                    setLocalMaterialsData((prev) => ({
                      ...prev,
                      [item.formula]: {
                        molar_frac: e.target.value,
                        desValue: localMaterialsData[item.formula]?.desValue ?? item.desValue,
                        cas: localMaterialsData[item.formula]?.cas_code ?? item.cas_code,
                        name: localMaterialsData[item.formula]?.formula ?? item.formula,
                        chineseName: localMaterialsData[item.formula]?.name ?? item.name,
                      },
                    }));
                  }}
                  style={{ flex: 1 }}
                />
                {(designVisible?(
                  <Input
                    value={localMaterialsData[item.formula]?.desValue ?? ""}
                    onChange={(e) => {
                      setLocalMaterialsData((prev) => ({
                        ...prev,
                        [item.formula]: {
                          molar_frac: localMaterialsData[item.formula]?.molar_frac ?? item.molar_frac,
                          desValue: e.target.value,
                          cas: localMaterialsData[item.formula]?.cas_code ?? item.cas_code,
                          name: localMaterialsData[item.formula]?.formula ?? item.formula,
                          chineseName: localMaterialsData[item.formula]?.name ?? item.name,
                        },
                      }));
                    }}
                    style={{flex:1,marginLeft:10}}
                  />
                ):null)}
              </div>
            ))}
        </div>
      </div>

      <Modal
        zIndex={2000}
        closable={false}
        centered={true}
        footer={null}
        width={500}
        className={"modal"}
        open={modalVariable}
        onCancel={()=>{setModalVariable(false);setCopyMaterialsDataTxt("");}}
      >
        <div style={{marginBottom:20,fontSize:20,fontWeight:"bold",color:"#1b6ae7"}}>粘贴组分摩尔分率</div>
        <div>
          <Input.TextArea
            autoSize={{maxRows:undefined}}
            value={copyMaterialsDataTxt}
            onChange={(e) => {setCopyMaterialsDataTxt(e.target.value);}}
            style={{ flex: 1,minHeight:400,maxHeight:400}}
          />
        </div>
        <div style={{height:32}}>
          <button
            onClick={()=>{{setModalVariable(false);setCopyMaterialsDataTxt("");}}}
            style={{position:"absolute",right:25,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#FF4D4F",color:"#FFF",fontSize:14}}
          >取消</button>
          <button
            onClick={()=>{copyMaterialsData();}}
            style={{position:"absolute",right:138,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#1b6ae7",color:"#FFF",fontSize:14}}
          >确认</button>
        </div>
      </Modal>

      <Modal
        zIndex={2000}
        closable={false}
        centered={true}
        footer={null}
        width={500}
        className={"modal"}
        open={fastModalVariable}
        onCancel={()=>{closeFastModal();}}
      >
        <div style={{marginBottom:20,fontSize:20,fontWeight:"bold",color:"#1b6ae7"}}>快捷输入</div>
        <div>
          <Input.TextArea
            autoSize={{maxRows:undefined}}
            value={fastJsonStr}
            onChange={(e) => {setFastJsonStr(e.target.value);}}
            style={{ flex: 1,minHeight:400,maxHeight:400}}
          />
        </div>
        <div style={{height:32,marginTop:0}}>
          <div style={{marginLeft:20,color:"#9e9e9e",fontSize:12,position:"absolute",left:5,bottom:20}}>
            <WarningOutlined style={{marginRight:5,color:"orange"}}/>
            提示：仅包含无子项的参数
          </div>
          <button
            onClick={()=>{closeFastModal();}}
            style={{position:"absolute",right:25,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#FF4D4F",color:"#FFF",fontSize:14}}
          >取消</button>
          <button
            onClick={()=>{confirmFastJson();}}
            style={{position:"absolute",right:138,bottom:10,width:88,height:32,border:0,borderRadius:5,background:"#1b6ae7",color:"#FFF",fontSize:14}}
          >确认</button>
        </div>
      </Modal>

    </>
  );
};

export default ParameterEditor;